import { formatDate } from '@doda/common/src/logics/JobContent/createFormatDate';
import { Text } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * ランキングサマリのProps
 * @property label 検索軸名
 * @property updatedDate 更新日
 */
interface RankingSummaryProps {
  label?: string;
  updatedDate: string;
}

/**
 * ランキングサマリ
 */
export const RankingSummary = ({ label, updatedDate }: RankingSummaryProps) => {
  const title = label?.trim()
    ? `${label}の人気求人ランキング`
    : '人気求人ランキング';

  return (
    <div className={styles.jobRankingSummary}>
      <Text size="20" weight="bold" color="black_pc" as="h2">
        {title}
      </Text>
      <Text size="14--articlePC" color="black_pc">
        dodaに掲載中の求人を、応募数順にランキング形式でご紹介します。
        <br />
        ※応募数が同数の場合は、新着順に表示しています。
      </Text>
      <Text
        size="12"
        color="gray"
        className={styles.jobRankingSummary__updatedDate}
      >
        更新日：{formatDate(updatedDate)}
      </Text>
    </div>
  );
};
